export default __webpack_public_path__ + "static/media/location-normal.5b09f1b2.svg";